import { render } from "./Fe.vue?vue&type=template&id=832cc864"
import script from "./Fe.vue?vue&type=script&lang=js"
export * from "./Fe.vue?vue&type=script&lang=js"

import "./Fe.vue?vue&type=style&index=0&id=832cc864&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__